export default "__VITE_ASSET__DGkUjqYw__"